import React from 'react';
import '../css/header.scss';

function Header() {

  return (
    <header>
      <ul>
        <li data-scroll='intro' className='active'>HOME</li>
        <li data-scroll='skill'>SKILL</li>
        <li data-scroll='portfoilo'>PORTFOILO</li>
      </ul>
    </header>
  )
}

export default Header;